<template>
  <div class="attachment-preview">
    <img class="attachment-preview-icon" src="@/assets/image-document.svg" alt="Nahraný obrázok" />
    <h3 class="attachment-preview-name">
      <button
        type="button"
        class="m-reset-button"
        @click="$emit('open')"
      >
        {{ attachment.clientName?.substring(0, 20) }}
      </button>
    </h3>
    <button
      type="button"
      class="m-reset-button attachment-preview-remove"
      @click="$emit('remove')"
    >
      <BaseIcon icon="cross" />
    </button>
  </div>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  attachment: {
    type: Object,
    default: () => ({
      clientName: null,
      fileName: null,
    }),
  },
});

defineEmits(['remove']);
</script>

<style scoped>
.attachment-preview {
  display: flex;
  align-items: center;
  gap: 8px;
}

.attachment-preview-name {
  flex: 1;
  overflow: hidden;
}

.attachment-preview-icon {
  width: 32px;
  min-width: 32px;
}
</style>
